module.exports = __webpack_public_path__ + "static/media/3.605f57ee.svg";